'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.hasSessionStorage = hasSessionStorage;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SESSION_TOKEN_KEY = 'AccessToken';
var SESSION_REFRESH_TOKEN_KEY = 'RefreshToken';

/**
 * Checks if the browser has the capabilities to handle a session storage
 *
 * @returns {boolean}
 */
function hasSessionStorage(sessionStorage) {
    try {
        if (typeof sessionStorage === 'undefined') {
            // browser doesn't support sessionStorage
            return false;
        }

        var testKey = 'testKey';
        var testValue = 'testValue';
        sessionStorage.setItem(testKey, testValue);
        if (sessionStorage.getItem(testKey) === testValue) {
            sessionStorage.removeItem(testKey);
            return true;
        } else {
            return false;
        }
    } catch (e) {
        // e.g. browser doesn't accept cookies
        return false;
    }
}

/**
 * Provides functionality to manipulate and check a browsers
 * session storage that keeps a user session.
 * Maximum session lifetime until the browser is closed.
 */

var SessionStorage = function () {
    function SessionStorage() {
        (0, _classCallCheck3.default)(this, SessionStorage);
    }

    (0, _createClass3.default)(SessionStorage, [{
        key: 'getRefreshToken',
        value: function getRefreshToken() {
            return sessionStorage.getItem(SESSION_REFRESH_TOKEN_KEY);
        }
    }, {
        key: 'saveRefreshToken',
        value: function saveRefreshToken(token) {
            sessionStorage.setItem(SESSION_REFRESH_TOKEN_KEY, token);
        }
    }, {
        key: 'deleteRefreshToken',
        value: function deleteRefreshToken() {
            sessionStorage.removeItem(SESSION_REFRESH_TOKEN_KEY);
        }
    }, {
        key: 'getSessionToken',
        value: function getSessionToken() {
            return sessionStorage.getItem(SESSION_TOKEN_KEY);
        }
    }, {
        key: 'saveSessionToken',
        value: function saveSessionToken(token) {
            sessionStorage.setItem(SESSION_TOKEN_KEY, token);
        }
    }, {
        key: 'deleteSessionToken',
        value: function deleteSessionToken() {
            sessionStorage.removeItem(SESSION_TOKEN_KEY);
        }
    }, {
        key: 'isLoggedIn',
        value: function isLoggedIn() {
            return sessionStorage.getItem(SESSION_TOKEN_KEY) !== null;
        }
    }]);
    return SessionStorage;
}();

exports.default = SessionStorage;
